/* eslint-disable camelcase */

import {
    PixelRatio,
    Dimensions,
    Platform,
    AsyncStorage,
    NetInfo
} from 'react-native';

import {
    JDJumping,
    JDNativeToast,
    JDNativeSystem,
    JDMta,
    JDLogin,
    JDShare
} from '@jdreact/jdreact-core-lib';

import Storage from 'react-native-storage';

import CryptoJS from 'crypto-js';
import { post } from './fetch';

global.storage = new Storage({
    storageBackend: Platform.OS === 'web' ? window.localStorage : AsyncStorage,
    defaultExpires: null
});

global.is_x = JDNativeSystem.isIPhoneX;

global.iphoneXMarginBottom = JDNativeSystem.iphoneXMarginBottom;

global._alert = function(json) {
    // alert(JSON.stringify(json, null, 4));
};
global.openingHintStorage = new Storage({
    defaultExpires: null
});
global.openingHintTimerOne = null;
global.openingHintTimerTwo = null;

let toast_time = 2;

let { width, height } = Dimensions.get('window');

if (Platform.OS === 'android') {
    if (width > height) {
        width = Dimensions.get('window').height;
        height = Dimensions.get('window').width;
    };
    toast_time = 2000;
};

export const innerWidth = width;

export const innerHeight = height;

const dpr = parseInt(PixelRatio.get(), 10) || 1;

export const is_android = Platform.OS === 'android';

export const is_web = Platform.OS === 'web';

export const isWeb = Platform.OS === 'web';

export const getClientVersion = () => {
    if (is_web) {
        const ua = (navigator && navigator.userAgent) || '';

        const client = ua.split(';');

        window.isJDApp = /jdapp/.test(ua);
        window.appVersion = (client && client[2]) || '';
        window.isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
        window.isIOS = ua.indexOf('like Mac OS X') > -1;
        window.is_x = isIOS && (screen.height === 812 || screen.height === 896);
        global.iphoneXMarginBottom = window.iphoneXMarginBottom = is_x && isJDApp ? 34 : 0;
    }
};

export const assign = (state, obj) => {
    return Object.assign({}, state, obj);
};

export const pt = num => num * width / 375;

export const px = num => num / dpr;

export const diff = (day, diffday) => {
    return ~~((new Date(day) - new Date(diffday)) / 864e5);
};

export const diff_date = (day, diffday) => {
    return Math.ceil((new Date(day) - new Date(diffday)) / 864e5);
};

export const complement = num => num < 10 ? '0' + (num - 0) : num;

// 返回 星期
export const getWeek = (day) => {
    if (day == 'null') { return ''; }
    const dayS = (/\-/g.test(day)) ? day.replace(/\-/g, '/') : day;

    const getday = new Date(dayS).getDay();

    const week = ['日', '一', '二', '三', '四', '五', '六'];

    return '周' + week[getday];
};

export const ms_to_week = (ms) => {
    const map = ['日', '一', '二', '三', '四', '五', '六'];

    const day = new Date(ms).getDay();

    return '周' + map[day];
};

export const trim_time = (ms) => {
    const date = new Date(ms);

    const y = date.getFullYear();

    const m = date.getMonth();

    const d = date.getDate();

    return new Date(y, m, d) - 0;
};

export const trimTime = (ms) => {
    const date = new Date(ms);

    const y = date.getFullYear();

    const m = date.getMonth();

    const d = date.getDate();

    return new Date(y, m, d) - 0;
};

export const format_date = (ms) => {
    const date = date_str(ms);

    const week = ms_to_week(ms);

    const time = complement(new Date(ms).getHours()) + ':' + complement(new Date(ms).getMinutes());

    return `${date.slice(5, 12)}(${week}) | ${time}`;
};

export const date_str = (ms, ch) => {
    const date = new Date(ms);

    const y = date.getFullYear();

    const m = date.getMonth() + 1;

    const d = date.getDate();

    return ch ? `${y}年${complement(m)}月${complement(d)}日` : `${y}-${complement(m)}-${complement(d)}`;
};

export const time_str = (ms) => {
    const date = new Date(ms);

    const y = date.getFullYear();

    const m = date.getMonth() + 1;

    const d = date.getDate();

    const time = complement(new Date(ms).getHours()) + ':' + complement(new Date(ms).getMinutes()) + ':' + complement(new Date(ms).getSeconds());

    return `${y}-${complement(m)}-${complement(d)} ${time}`;
};

export const format = (ms, separate) => {
    const date = new Date(ms);

    const y = date.getFullYear();

    const m = date.getMonth() + 1;

    const d = date.getDate();

    const se = separate || '-';

    return `${y}${separate}${complement(m)}${separate}${complement(d)}`;
};

export const tip = (text, toast_time) => {
    JDNativeToast.show(text, toast_time, 2);
};

export const success = text => {
    JDNativeToast.show(text, toast_time, 0);
};

export const warn = text => {
    JDNativeToast.show(text, toast_time, 1);
};

export const add = (arg1, arg2) => {
    let r1, r2, m, c;

    try {
        r1 = arg1.toString()?.split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString()?.split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        const cm = Math.pow(10, c);

        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace('.', ''));
            arg2 = Number(arg2.toString().replace('.', '')) * cm;
        } else {
            arg1 = Number(arg1.toString().replace('.', '')) * cm;
            arg2 = Number(arg2.toString().replace('.', ''));
        }
    } else {
        arg1 = Number(arg1.toString().replace('.', ''));
        arg2 = Number(arg2.toString().replace('.', ''));
    }

    return (arg1 + arg2) / m;
};

export const sub = (arg1, arg2) => {
    let r1, r2, m, n;

    try {
        r1 = arg1.toString()?.split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString()?.split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;

    return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

export const mul = (arg1, arg2) => {
    let m = 0;

    const s1 = arg1.toString();

    const s2 = arg2.toString();

    try {
        m += s1.split('.')[1].length;
    } catch (e) { }
    try {
        m += s2.split('.')[1].length;
    } catch (e) { }

    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
};

// 加密解密
export const encrypt = (content, key) => {
    const key1 = CryptoJS.enc.Utf8.parse(key);

    return CryptoJS.AES.encrypt(content, key1, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
};

export const decrypt = (content, key) => {
    const key1 = CryptoJS.enc.Utf8.parse(key);

    return CryptoJS.AES.decrypt(content, key1, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
};

/**
 *
 * @param {*} event_id 事件Id
 * @param {*} page 页面page_id *
 * @param {*} event_param 事件参数
 * @param {*} page_param 页面参数
 * 无参数点击 mta('CityHot','City')
 * 有参数点击 mta('CityHot','City','参数信息', '页面参数')
 *
 */
export const mta = (event_id, page_id, event_param = '', page_param = '') => {
    // if (is_web) {
    //     JDMta.sendClickData(`M_Movie_${event_id}`, event_param, '', `M_Movie_${page_id}_page`, page_param, '', `M_Movie_${page_id}`, '', '');
    // } else {
    JDMta.sendClickData(`Movie_${event_id}`, event_param, '', `Movie_${page_id}_page`, page_param, '', `Movie_${page_id}`, '', '');
    // }
    // console.log(`Movie_${event_id}`, event_param, '', `Movie_${page_id}_page`, page_param, '', '', `Movie_${page_id}`,'点击埋点信息')
};

// 辅营埋点  本组件没有固定pageId
export const fy_mta = (eventId, event_param = '') => {
    JDMta.sendClickData(eventId, event_param, '', '', '', '', '', '');
};

/**
 *
 * @param {*} page_id
 * @param {*} page_param
 * 无参数PV mtaPV('City')
 * 有参数PV mtaPV('City','参数信息')
 */
export const mtaPV = (page_id, page_param = '') => {
    JDMta.isReportDefaultPageParam = false;
    JDMta.sendPvData(`Movie_${page_id}_page`, page_param, `Movie_${page_id}`, '');
    // console.log(`Movie_${page_id}_page`, page_param, `Movie_${page_id}`,'PV埋点信息')
};

export const share = (url, title, msg, shareImage) => {
    JDShare.showShareDialog(
        'https://hotel.m.jd.com',
        '京东酒店',
        '订酒店，上京东！超值特惠任您选！低价促销天天有！酒店套餐享不停',
        'https://misc.360buyimg.com/lt/lt_common/img/jdLogo.jpg',
        'movie'
    ).then(() => {
        console.log('success');
    }, () => {
        console.log('error');
    });
};

export const getPosition = () => {
    // 获取位置再得到城市先后顺序，通过Promise完成
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((position) => {
            resolve([position.coords.latitude, position.coords.longitude]);
        });
    });
};

export const getLabel = (score) => {
    let label = '看过，';

    if (score > 8) { // 9 10
        label += '棒极了';
    } else if (score > 6) { // 7 8
        label += '还不错';
    } else if (score > 4) { // 5 6
        label += '一般般';
    } else if (score > 2) { // 3 4
        label += '比较差';
    } else { // 1 2
        label += '超烂的';
    }

    return label;
};

export const pos = (x) => {
    return x * 10 / pt(10);
};

/* 获取显示的想看人数 */
export const getNum = (n) => {
    return n > 100000 ? Math.floor(n / 10000) + 'w+' : n || 0;
};

export const getByteLen = (val) => {
    let len = 0;

    for (let i = 0; i < val.length; i++) {
        const length = val.charCodeAt(i);

        if (length >= 0 && length <= 128) {
            len += 1;
        } else {
            len += 2;
        }
    }

    return len;
};

export const clip = (val, length) => {
    let v = val;

    while (getByteLen(v) > length) {
        v = v.slice(0, -1);
    }

    return v;
};

export const actorType = {
    0: '未知',
    1: '演员',
    2: '导演',
    3: '副导演/助理导演',
    4: '编剧',
    5: '制片人',
    6: '监制',
    7: '音乐',
    8: '摄影',
    9: '剪辑',
    10: '艺术指导',
    11: '美术设计',
    12: '服装设计',
    13: '化妆',
    14: '特效',
    15: '视觉效果',
    17: '翻译',
    18: '特别顾问',
    19: '录音',
    20: '音效',
    21: '灯光',
    22: '策划',
    23: '出品人',
    24: '原著作者',
    25: '动作指导',
    26: '鸣谢',
    27: '道具',
    28: '替身'
};

export const isNetWork = () => {
    return new Promise((resolve, reject) => {
        NetInfo?.getConnectionInfo().done((res) => {
            resolve(res);
        });
    });

    if (is_web && isJDApp) {
        if (isIOS) {
            window.location.href = 'openapp.jdmobile://virtual?params={"category":"jump","des":"share","type":"111","title":"","content":"","shareUrl":"","imageUrl":"","iconUrl":"","timeline_title":"","qrparam":null,"channel":"","isCallBack":"N","clickcallback":"N","shareActionType":"S"}';
        } else {
            window.MobileNavi && window.MobileNavi.configBtnSince610(jsonString);
        }
    }
};

export const old_movie_host = 'https://m-movie.jd.com/va';
//  export const old_movie_host = 'https://yfmovie.jd.com';

export const weixin_share_url = 'https://h5-movie.jd.com';

export const saveSession = (key, obj) => {
    if (!obj || obj == null || obj == undefined) {
        return;
    }
    sessionStorage.setItem(key, JSON.stringify(obj));
};

export const fetchSession = (key) => {
    return JSON.parse(sessionStorage.getItem(key));
};

export const saveLocal = (key, obj) => {
    if (!obj || obj == null || obj == undefined) {
        return;
    }
    localStorage.setItem(key, JSON.stringify(obj));
};

export const fetchLocal = (key) => {
    return JSON.parse(localStorage.getItem(key));
};

export const getQuery = (key) => {
    const parseStr = function(str, substr, delim) {
        const start = str.indexOf(substr + '=');

        if (start === -1) return '';
        let end = str.indexOf(delim, start);

        if (end === -1) {
            end = str.length;
        }

        return decodeURI(str.substring(start + substr.length + 1, end));
    };

    return parseStr(window.location.search, key, '&');
};

// 判断金融渠道
export const getCookie = (sName) => {
    const aCookie = document.cookie.split('; ');

    for (let i = 0; i < aCookie.length; i++) {
        const aCrumb = aCookie[i].split('=');

        if (sName == aCrumb[0]) { return unescape(aCrumb[1]); }
    }

    return null;
};

// 屏蔽站内分享按钮
export const closeShare = () => {
    const jsonString = JSON.stringify({
        hidemore: {
            type: 'share',
            display: 'hide' // show, hide'
        }
    });

    if (is_web && isJDApp) {
        if (isIOS) {
            window.location.href = 'openapp.jdmobile://virtual?params={"category":"jump","des":"share","type":"111","title":"","content":"","shareUrl":"","imageUrl":"","iconUrl":"","timeline_title":"","qrparam":null,"channel":"","isCallBack":"N","clickcallback":"N","shareActionType":"S"}';
        } else {
            window.MobileNavi && window.MobileNavi.configBtnSince610(jsonString);
        }
    }
};

export const LBSbusinessId = 'ce5f2a374face7d0a44ed35577dae678';

export const sceneId = 'locService';

/**
 * 路由参数简单加密
 * @param data
 * @returns {string}
 */
export const routeEncryption = (data) => {
    return encodeURIComponent(JSON.stringify(data));
};

/**
 * 路由参数简单解密
 * @param data
 */
export const routeDecryption = (data) => {
    try {
        return JSON.parse(decodeURIComponent(data));
    } catch (e) {}
};

/**
 * 金额两位数处理
 * @param money
 * @returns {number}
 */
export const moneyHandle = (money) => {
    return (money / 100).toFixed(2) - 0;
};

// map 转对象
export const strMapToObj = (strMap) => {
    const obj = Object.create(null);// 创建空的对象

    for (const [k, v] of strMap) {
        obj[k] = v;
    }

    return obj;
};

// 对象转 map
export const objStrToMap = (obj) => {
    Object.entries(obj);

    return new Map(Object.entries(obj));
};

export const fenToYuan = (price) => {
    return price ? Number((+price / 100).toFixed(2)).toString() : '';
};

// 跳转地图导航
export const toMap = (info) => {
    if (!info) {
        return;
    }

    console.log('info', info);

    getJumpMapUrl(info);
};

/**
 * 请求接口获取配置数据
 * @returns {Promise} 返回请求结果的Promise
 */
export async function getJumpMapUrl(info) {
    const { cinemaId, cinemaName, lat, lon, lng, address } = info || {};

    const params = {
        // 影院id
        cinemaId,
        // 影城名称 (对应字段cinemaName)
        cinemaName: cinemaName,
        // 影城地址 (cinemaAddress)
        cinemaAddress: address,
        // 坐标 (lon、lat)
        cinemaLongitude: lng || lon,
        cinemaLatitude: lat
    };

    try {
        const res = await post('movie_cinemaJumpMapUrl', params, true);

        if (res?.data?.jumpUrl) {
            jumpTo(res.data.jumpUrl);
        } else {
            throw new Error(res);
        }
    } catch (error) {
        console.log('fetchConfig error', error);
        toMapLegacy(params);
    }
};

export function jumpTo(url) {
    console.log('url', url);
    if (url.search(/^http/i) === 0) { // 'http'开头  （忽略大小写）
        JDJumping.jumpToWeb(url).catch(err => tip(err));
    } else if (url.search(/^openapp/i) === 0) { // 'openApp'或 'openapp' 开头 （忽略大小写）
        JDJumping.jumpToOpenapp(url).catch(err => { console.log(err); });
    } else {
        console.log('url 不存在', url);
    }
};

// 兜底的地图导航方法
const toMapLegacy = (data) => {
    const { cinemaLongitude, cinemaLatitude, cinemaName, cinemaAddress } = data || {};

    if (cinemaLongitude && cinemaLatitude) {
        const addrStr = 'coord:' + cinemaLatitude + ',' + cinemaLongitude + ';title:' + encodeURIComponent(cinemaName) + ';addr:' + encodeURIComponent(cinemaAddress) + '&referer=YSHBZ-MTHK5-BFMIG-QCLZ7-SSK72-6VF2G';

        const url = 'https://apis.map.qq.com/uri/v1/marker?marker=' + addrStr;

        jumpTo(url);
    }
};
